t = require('app/scripts/views/internal/teacup-with-helpers')('popover_about_this_board_admin_list')

module.exports = ->
  t.div '.about-this-board-admin-list-popover', ->
    t.ul '.js-admin-list', ->
      t.li '.pop-over-member-list', ->
        t.span '.name.js-show-all-admins'
